import clsx from "clsx"

import type { AlertTextSlice } from "~/api/prismic/types"
import CustomRichText from "~/components/CustomRichText"
import TailwindProseWrapper from "~/components/TailwindProseWrapper"

export type AlertTextProps = {
  slice: AlertTextSlice
}

export const AlertText: React.FC<AlertTextProps> = ({ slice }) => {
  const { color, text } = slice.primary

  return (
    <TailwindProseWrapper
      className={clsx(
        "border-l-4 p-4 py-6",
        "dark:border-y-4 dark:border-l-0 dark:bg-transparent",
        {
          "border-blue-300 bg-blue-100": color === "blue",
          "border-yellow-300 bg-yellow-100": color === "yellow",
          "border-red-300 bg-red-100": color === "red",
        },
      )}
    >
      <CustomRichText field={text} />
    </TailwindProseWrapper>
  )
}
